<template>
  <div id="ppwApp">

    <!-- //this can be done better.... homepage and default page has "wide" template   nog doen: v-else-if="$route.name == 'paginacontent'" -->
    <div v-if="$route.path == '/'" class="app-container app-container__wide">
      <mainNav></mainNav> 
      <main>
        <router-view :key="$route.path" ref="content"  />
      </main>
    </div>

    <!-- or default page -->
    <div v-else-if="$route.name == 'paginacontent'" class="app-container app-container__wide">
      <mainNav></mainNav>
      <main>
        <router-view :key="$route.path" ref="content"  />
      </main>
    </div>

    <!-- or default page -->
    <div v-else-if="$route.name == 'versieHTML'" class="app-container app-container__html">
      <main>
        <router-view :key="$route.path" ref="content"  />
      </main>
    </div>

    <!-- app container, different less wide template -->
    <div v-else class="app-container">
      <mainNav :titel="titel"></mainNav>
      <main>
        <router-view :key="$route.path" ref="content"  />
      </main>
    </div>

    
    <!-- lightbox -->
    <div id="lightbox" class="lightbox">
      <div class="lightbox-inner">
        <span class="lightbox-close icon-close" @click="hideLightbox()"></span>
        <div class="lightbox-inner--content" id="lightbox-content">
        </div>
      </div>
    </div>
    <!-- end lightbox -->

  </div>
</template>

<script>
  // import DEV from './dev';
  import mainNav from './components/mainNav.vue';
  import tools from "./lib/tools";

  const ENDPOINT_NAME = 'ppw/v1/methodes';
  const axios = require('axios');
  
  export default {
    name: "App",

    data() {
      return {
        pageTemplate: "homepage",
        path: "",
        titel: 'ParticipatieWijzer',
      }
    },

    components: {
      mainNav,
    },

    computed: {
      // setMethodid: function() {
      // }
    },
    
    methods: {
      showPath: function(v) {
        this.path = v
      },

      hideLightbox: function() {
        // Hide Lightbox
        document.getElementById('lightbox').classList.toggle("active");
        
        // Empty Lightbox
        let lightboxContent = document.getElementById('lightbox-content');
        lightboxContent.innerHTML = '';

      },

      setNavClass() {
      },
    },

    created() {
    },

    mounted() {
      if (this.$route.name == 'versieHTML')
        this.titel = 'Uw eindresultaat als HTML';
    }

  };
</script>

